<template>
  <div>
    <Solutions/>
    <MailjetNewsLetter/>
  </div>
</template>

<script>
import Solutions from '../components/Solutions'
import MailjetNewsLetter from '../components/MailjetNewsLetter'

export default {
  name: 'Homepage',
  components: {
    Solutions,
    MailjetNewsLetter
  },
  props: {
  },
  created(){
    // this.$matomo && this.$matomo.trackPageView()
    // console.log(this.$matomo)
  },
  mounted(){
    /*var _paq = window._paq = window._paq || [];
    window.addEventListener('hashchange', function() {
        _paq.push(['trackPageView']);
    });*/
    // this.$matomo && this.$matomo.trackPageView()
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  header {
  position: relative;
  top: 0;
  background-color: black;
  height: 75vh;
  min-height: 25rem;
  width: 100%;
  overflow: hidden;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: black;
    opacity: 0.5;
    z-index: 1;
  }
  .container {
    position: relative;
    z-index: 2;
  }
}

header {
  video {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 100vh;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: 0;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
}

  

  .solution-preview{
    margin: 100px 0px;
    img{
      padding: 20px;
    }
  }
  .title-block {
      font-size: 45px;
      margin-bottom: 20px;
    }
  .dark-block{
    min-height: 200px;
    color: white;
    font-size: 20px;
    background-color: var(--mainBlue);
    padding: 20px;
    border-radius: 18px;
    text-align: left;
  }
  .light-block{
    min-height: 200px;
    font-size: 20px;
    padding: 20px;
    border-radius: 18px;
    text-align: left;
  }

  .contact-block {
    color: white;
    font-weight: 600;
    font-size: 25px;
    background-color: var(--mainBlue);
    padding: 20px;
    border-radius: 18px;
    text-align: center;
    .tagline{
      padding: 50px 0px 20px 0px;
    }
    .styledInput{
      margin: auto;
      border-radius: 20px;
      max-width: 300px;
      margin-bottom: 50px;
      .input-group-append{
        max-width: 300px;
        
        .btn-input{
        background-color: var(--mainGreen);
        color: white;
      }
      }
    }
  }
  .clients-logo{
    .logoContainer{
      background-color: #f9f9f9;
      padding: 5px;
      border-radius: 25px;
      border: white 10px solid;
      img{
        margin-top: 15px;
        margin-bottom: 5px;
        filter: grayscale(100%);
      }
      &:hover {
        img{
          filter: none;
        }
      }
    }
  }

</style>
